import { render, staticRenderFns } from "./Ww.vue?vue&type=template&id=21645490&"
import script from "./Ww.vue?vue&type=script&lang=js&"
export * from "./Ww.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports